<template>
    <draggable
        v-bind="dragOptions"
        tag="div"
        class="item-container"
        :list="list"
        :value="value"
        @input="emitter"
        @change="emitterChange">

        <div class="item-group" :key="folder.id" v-for="folder in realValue">
            <div class="item ">
                <div class="flex justify-between w-100 hover:bg-grey-lighter">
                    <div class="folder">{{ folder.original_name }}</div>
                    <div class="">
                        <button
                            class="font-semibold p-2 text-followup-nav ml-1"
                            id="folderDropdown" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-ellipsis-v mx-2"></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="folderDropdown">
                            <button @click="addSubFolder(folder.id, folder.name)" class="dropdown-item">
                                Add Folder
                            </button>
                            <button @click="renameSubFolder(folder.id, folder.name,folder.order)" class="dropdown-item">
                                Rename
                            </button>
                            <button v-if="canDeleteFolders" @click="deleteFolder(folder)" class="dropdown-item">Delete</button>
                        </div>
                    </div>
                </div>
            </div>
            <nested class="item-sub" :list="folder.children" :canDeleteFolders="canDeleteFolders"/>
        </div>
    </draggable>
</template>

<script>
import draggable from "vuedraggable";
import Form from "../../utils/form";

export default {
    name: "nested",
    components: {
        draggable
    },
    props: {
        value: {
            required: false,
            type: Array,
            default: null
        },
        list: {
            required: false,
            type: Array,
            default: null
        },
        canDeleteFolders: {}
    },
    data() {
        return {
            data: null,
            data_loading: false,
            form: new Form({
                id: null,
                name: '',
                order: null,
            }),
            subFolderForm: new Form({
                id: null,
                folder_name: '',
                parent_folder_id: '',
                parent_folder: null,
                order: null,
            }),
            editing: false,
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },
        realValue() {
            return this.value ? this.value : this.list;
        }
    },
    mounted() {
        let self = this;
        $("#fileFolderModal").on('hidden.bs.modal', function () {
            self.form.reset();
            self.editing = false;
        });
    },
    methods: {
        emitter(value) {
            Bus.$emit("UpdateStateEmitterFolder", value);
        },
        emitterChange(value) {
            Bus.$emit("UpdateStateFolder", value);
        },
        deleteFolder(folder) {
            Bus.$emit('deleteSubFolderEmit',folder);

        },

        addSubFolder(folderId, folderName) {

            this.subFolderForm.parent_folder = folderName;
            this.subFolderForm.parent_folder_id = folderId;
            Bus.$emit('addSubFolderEmit',this.subFolderForm);
        },
        renameSubFolder(folderId, folderName,folderOrder) {

            this.form.id = folderId;
            this.form.name = folderName;
            this.form.order = folderOrder;
            Bus.$emit('renameSubFolderEmit',this.form);
        }
    },

};
</script>
<style scoped>
.item-container {
    margin: 0;
}
.item {
    padding: 5px;
}
.item-sub {
    margin: 0 0 0 1rem;
}
</style>
<style scoped>
.folder:before {
    font-family: 'FontAwesome';
    content: "\f07b";
    display: inline-block;
    padding-right: 5px;
    vertical-align: middle;
    font-weight: 900;
    font-size: 30px;
}
</style>
